(function () {
  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (cents % 100 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function updateAll() {
    const containers = document.querySelectorAll('[data-shipping-progress]');
    if (!containers.length) return;

    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        containers.forEach((container) => {
          const threshold = parseInt(container.dataset.threshold, 10);
          const textEl = container.querySelector('[data-shipping-text]');
          const fillEl = container.querySelector('[data-shipping-fill]');
          const total = cart.total_price;

          let percent = 0;
          if (total >= threshold) {
            percent = 100;
            textEl.textContent = container.dataset.successText;
          } else if (total === 0) {
            percent = 0;
            textEl.textContent = container.dataset.emptyText;
          } else {
            percent = (total / threshold) * 100;
            const template = container.dataset.progressText;
            textEl.textContent = template.replace('[remaining]', formatMoney(threshold - total));
          }
          fillEl.style.width = percent + '%';
        });
      })
      .catch(() => {});
  }

  function init() {
    updateAll();
    if (window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateAll);
    }
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      const promise = origFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
      if (url && /\/cart\/(add|change|update|clear)/i.test(url)) {
        promise.then(() => setTimeout(updateAll, 50)).catch(() => {});
      }
      return promise;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();